<template>
  <div class="min-h-screen flex flex-col">
    <Navbar />

    <main class="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Breadcrumbs :items="[{ label: 'Cookie Policy' }]" />
      
      <div class="card mt-6">
        <div class="p-8 prose dark:prose-invert max-w-none">
          <h1 class="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-6">
            Cookie Policy
          </h1>
          
          <p class="text-sm text-gray-500 dark:text-gray-400 mb-8">
            Last updated: {{ new Date().toLocaleDateString() }}
          </p>

          <div class="space-y-6 text-gray-700 dark:text-gray-300">
            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">1. What Are Cookies</h2>
              <p>
                Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide information to the owners of the site.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">2. How We Use Cookies</h2>
              <p>
                Neutral Fuels uses cookies to:
              </p>
              <ul class="list-disc pl-6 mt-2 space-y-1">
                <li>Keep you signed in</li>
                <li>Remember your preferences and settings</li>
                <li>Understand how you use our platform</li>
                <li>Improve and optimize our services</li>
                <li>Ensure security and prevent fraud</li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">3. Types of Cookies We Use</h2>
              
              <div class="space-y-4">
                <div>
                  <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Essential Cookies</h3>
                  <p>
                    These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you such as setting your privacy preferences, logging in, or filling in forms.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Functional Cookies</h3>
                  <p>
                    These cookies enable enhanced functionality and personalization, such as remembering your theme preference (light/dark mode) and language settings.
                  </p>
                </div>

                <div>
                  <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Analytics Cookies</h3>
                  <p>
                    These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us understand which pages are the most and least popular.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">4. Managing Cookies</h2>
              <p>
                You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed. However, if you do this, you may have to manually adjust some preferences every time you visit our site.
              </p>
              <p class="mt-2">
                To manage cookies in your browser, consult your browser's help section or visit:
              </p>
              <ul class="list-disc pl-6 mt-2 space-y-1">
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" class="text-primary-600 dark:text-primary-400 hover:underline">Chrome</a></li>
                <li><a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" class="text-primary-600 dark:text-primary-400 hover:underline">Firefox</a></li>
                <li><a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac" target="_blank" class="text-primary-600 dark:text-primary-400 hover:underline">Safari</a></li>
                <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" class="text-primary-600 dark:text-primary-400 hover:underline">Edge</a></li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">5. Third-Party Cookies</h2>
              <p>
                Some cookies on our site are set by third-party services that appear on our pages. We use the following third-party services:
              </p>
              <ul class="list-disc pl-6 mt-2 space-y-1">
                <li>Firebase Authentication (Google)</li>
                <li>Firebase Cloud Firestore (Google)</li>
                <li>Chart.js (for data visualization)</li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">6. Updates to This Policy</h2>
              <p>
                We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons.
              </p>
            </section>
          </div>

          <div class="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
            <p class="text-sm text-gray-500 dark:text-gray-400">
              If you have any questions about our use of cookies, please contact us at:
            </p>
            <p class="text-sm text-gray-700 dark:text-gray-300 mt-2">
              <strong>Email:</strong> privacy@neutralfuels.net<br />
              <strong>Phone:</strong> +971 4 234 5678
            </p>
          </div>
        </div>
      </div>
    </main>

    <Footer />
  </div>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue'
</script>
